import { InstallerCompany } from '@/api/interfaces/installer/installerCompany';

export const installersContent: InstallerCompany[] = [
    {
        id: 'mock-installer-company-1',
        companyName: 'Muster Installateur GmbH',
        email: 'installateur@example.com',
        phoneNumbers: ['0123456789'],
        street: 'Musterstrasse',
        houseNumber: '1',
        zipCode: '26121',
        city: 'Oldenburg',
    },
];
